'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';
import { Bell, User, PanelRight, Sun, Moon } from 'lucide-react';
import { useTheme } from 'next-themes';
import { useLayoutStore } from '@/lib/stores/layout-store';
import { cn } from '@/lib/utils/cn';
import { LanguageToggle } from './language-toggle';

export function HeaderBar() {
  const { showSecondarySidebar, toggleSecondarySidebar } = useLayoutStore();
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Only render theme toggle after hydration to avoid mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  const toggleTheme = () => {
    setTheme(resolvedTheme === 'dark' ? 'light' : 'dark');
  };

  return (
    <header className="h-12 bg-card border-b border-border flex items-center px-4 gap-4">
      {/* Logo */}
      <div className="flex items-center">
        <Image
          src="/images/logo.png"
          alt="Klyde"
          width={64}
          height={20}
          className="dark:invert"
          priority
        />
      </div>

      {/* Spacer */}
      <div className="flex-1" />

      {/* Right side actions */}
      <div className="flex items-center gap-2">
        {/* Language Toggle */}
        <LanguageToggle />

        {/* Theme Toggle - only render icon after mount to avoid hydration mismatch */}
        <button
          onClick={toggleTheme}
          className="p-2 rounded hover:bg-muted transition-colors"
          title={mounted ? `Switch to ${resolvedTheme === 'dark' ? 'light' : 'dark'} mode` : 'Toggle theme'}
          suppressHydrationWarning
        >
          {mounted ? (
            resolvedTheme === 'dark' ? (
              <Sun className="w-5 h-5" />
            ) : (
              <Moon className="w-5 h-5" />
            )
          ) : (
            <Sun className="w-5 h-5 opacity-0" />
          )}
        </button>

        {/* Toggle Copilot Panel */}
        <button
          onClick={toggleSecondarySidebar}
          className={cn(
            'p-2 rounded hover:bg-muted transition-colors',
            showSecondarySidebar && 'bg-muted'
          )}
          title="Toggle Copilot Panel"
        >
          <PanelRight className="w-5 h-5" />
        </button>

        {/* Notifications */}
        <button className="p-2 rounded hover:bg-muted transition-colors relative">
          <Bell className="w-5 h-5" />
          <span className="absolute top-1 right-1 w-2 h-2 bg-destructive rounded-full" />
        </button>

        {/* User Menu */}
        <button className="p-2 rounded hover:bg-muted transition-colors">
          <User className="w-5 h-5" />
        </button>
      </div>
    </header>
  );
}

